export const constants = {
	iosUrl: 'https://apps.apple.com/us/app/myhrs/id1584709781',
	androidUrl: 'https://play.google.com/store/apps/details?id=com.logmyhrs.api'
};


// WEBPACK FOOTER //
// ./src/data/constants.js